import type * as React from "react";

import { cx } from "../../lib/cx";
import { Icon, type IconName } from "./Icon";
import s from "./Chip.module.css";

export type ChipSize = "sm" | "md";

export interface ChipProps extends Omit<React.ComponentPropsWithoutRef<"button">, "type"> {
  selected?: boolean;
  icon?: IconName;
  size?: ChipSize;
  /** Dentro de un `ChipGroup` el rol lo pone el grupo; suelto, es un botón con `aria-pressed`. */
  role?: "radio" | "button";
}

/** Opción seleccionable en línea: un horario, un filtro, "guardar". Suelto es un toggle; en `ChipGroup`, un radio. */
export function Chip({ children, selected = false, icon, size = "md", role, className, ...rest }: ChipProps) {
  const esRadio = role === "radio";
  return (
    <button
      type="button"
      className={cx(s.chip, className)}
      data-size={size}
      data-selected={selected || undefined}
      role={esRadio ? "radio" : undefined}
      aria-checked={esRadio ? selected : undefined}
      aria-pressed={esRadio ? undefined : selected}
      {...rest}
    >
      {icon ? <Icon name={icon} size={size === "sm" ? 14 : 16} /> : null}
      {children}
    </button>
  );
}
